export default class SinglePage {
    constructor() {
        this.singlePostPage = document.querySelector('.single-post');
        this.singleEventPage = document.querySelector('.single-event');
        this.writtenContentBlocks = document.querySelectorAll('.written-content');
        // if on singlePostPage or singleEvent page and has written content blocks
        if ((this.singlePostPage && this.writtenContentBlocks.length) || (this.singleEventPage && this.writtenContentBlocks.length)) {
            this.init();
        }
    }
    init() {
        // copy social share list and move it to the side column to get correct and equal width compared to rest of top content
        const socialShare = document.querySelector('.social-share-list ');
        this.writtenContentBlocks.forEach((block) => {
            const sideColumn = block.querySelector('.side-column');
            sideColumn === null || sideColumn === void 0 ? void 0 : sideColumn.appendChild(socialShare.cloneNode(true));
        });
    }
}
